import { Component, ViewChild } from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {SignaturePad} from 'angular2-signaturepad/signature-pad';

@Component({
    selector: 'page-rib-select',
    templateUrl: 'rib-select.html',
})
export class RibSelect {

    public iban: string = "";
    public rib_info: any = false;
    public error_format : boolean = false;
    public error_key : boolean = false;
    constructor(
        public navCtrl: NavController,
        public viewCtrl: ViewController,
        public params: NavParams
    ) {
        this.rib_info=params.get('rib');
        if(this.rib_info && this.rib_info.iban)
            this.iban=this.rib_info.iban;
    }

    ionViewDidLoad() {


    }
    saveIban()
    {
        if(!this.checkIbanFormat(this.iban))
        {
            this.error_format=true;
        }
        else
        {
            this.error_format=false;
            if(!this.checkIbanKey(this.iban))
            {
                this.error_key=true;
            }
            else
            {
                this.error_key=false;
                let data = { success:true, iban:this.iban };
                this.viewCtrl.dismiss(data);
            }
        }
    }
    checkIbanFormat(iban)
    {
        //console.log(iban,iban.length,iban.replace(/-/gi,'').length);
        if(iban.length!=33)return false;
        if(iban.replace(/-/gi,'').length!=27)return false;
        return true;
    }
    checkIbanKey(iban)
    {
        return this.validateIBAN(iban)
    }
    validateIBAN(iban) {
        var newIban = iban.replace(/-/gi,'').toUpperCase();
        //console.log(newIban);
        var modulo = function (divident, divisor) {
                var cDivident:any = '';
                var cRest:any = '';

                for (var i in divident ) {
                    var cChar:any = divident[i];
                    var cOperator:any = cRest + '' + cDivident + '' + cChar;

                    if ( cOperator < parseInt(divisor) ) {
                        cDivident += '' + cChar;
                    } else {
                        cRest = cOperator % divisor;
                        if ( cRest == 0 ) {
                            cRest = '';
                        }
                        cDivident = '';
                    }

                }
                cRest += '' + cDivident;
                if (cRest == '') {
                    cRest = 0;
                }
                return cRest;
            };

        if (newIban.search(/^[A-Z]{2}/gi) < 0) {
            return false;
        }

        newIban = newIban.substring(4) + newIban.substring(0, 4);

        newIban = newIban.replace(/[A-Z]/g, function (match) {
            return match.charCodeAt(0) - 55;
        });

        return parseInt(modulo(newIban, 97), 10) === 1;
    }
    dismiss() {
        let data = { success:false };
        this.viewCtrl.dismiss(data);
    }
}



// WEBPACK FOOTER //
// ./src/pages/utils/rib-select/rib-select.ts